import React from 'react'
import RenderEmoji from './RenderEmoji'

function PromptMessageDisplay (props) {
  return (
    <RenderEmoji
      className='prompt-message-display'
      text={props.message}
      rich='true'
    />
  )
}

export default PromptMessageDisplay
